/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unknown-property */
import React, { useState, useMemo } from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  PodSection,
  ProductPod,
  ProductImage,
  ProductRating,
  PodSpacer,
  ProductATC
} from '@thd-olt-component-react/product-pod';
import { Checkmark } from '@one-thd/sui-icons';
import {
  bool as boolType,
  string as stringType,
  number as numType,
  func
} from 'prop-types';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { AddToList } from '@thd-olt-component-react/add-to-list';
import { iframeAnalytics } from '../utils/analytics';
import { TIMEOUT } from '../core/constants';

export const VerticalRecsDrawer = (props) => {
  const {
    itemId,
    storeId,
    position,
    preferredPriceFlag,
    parent,
    apiName,
    anchorProduct,
    strategy,
    isAppliance,
    channel,
    updateRecsATCButton
  } = props;

  const anchorId = (anchorProduct.length > 2) ? anchorProduct : 'n/a';
  const merchRec = useMemo(() => {
    return `MERCH=REC-_-${apiName}-_-${anchorId}-_-${position}-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a`;
  }, [anchorId, position]);

  const [buttonText, setButtonText] = useState('Add to Cart');
  const [loading, setLoading] = useState(false);

  const options = {
    host: typeof window !== 'undefined'
      ? window.location.origin
      : null,
    channel,
    paypal: false,
    hidden: true,
    bypassBss: false,
    misship: false,
    bss: false,
    directCheckout: true,
    alterBrowserHistory: true
  };

  const itemDetails = {
    itemId,
    quantity: 1,
    fulfillmentMethod: isAppliance ? 'DirectDelivery' : undefined,
    iframe: true
  };

  const iframeAnalyticsObject = {
    anchorProduct,
    itemId,
    position: (position + 1),
    apiName,
    strategy
  };

  const atcButtonLoading = () => {
    setLoading(true);
    if (typeof (window) !== 'undefined') {
      window?.top?.LIFE_CYCLE_EVENT_BUS?.trigger('cartItem.DD_EVENT', iframeAnalytics(iframeAnalyticsObject, 'atc'));
    }
  };

  const onSuccess = (response) => {
    updateRecsATCButton(response);
    setLoading(false);
    if (itemId === response?.data?.addToCart?.items[0]?.product?.itemId) {
      setButtonText(<><Checkmark color="brand" />&nbsp;Added to Cart</>);
    }
    setTimeout(() => {
      setButtonText('Add to Cart');
    }, TIMEOUT);
  };

  const onFail = () => {
    setLoading(false);
    setTimeout(() => {
      setButtonText('Add to Cart');
    }, TIMEOUT);
  };

  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{
        parent, position, scheme: apiName, anchorProduct, strategy
      }}
      render={(pod) => (
        <>
          <div className="sui-grid sui-grid-cols-3 sui-pr-2 sui-pl-2 sui-gap-2">
            <div className="sui-grid-cols-1">
              <ProductImage
                itemId={pod.itemId}
                target="_top"
                merchQueryParam={merchRec}
                iframeAnalyticsData={iframeAnalytics(iframeAnalyticsObject, 'click')}
                isIframe
              />
            </div>
            <div className="sui-col-span-2">
              <PodSection noPadding columnAlign>
                <ProductHeader
                  brand="above"
                  itemId={pod.itemId}
                  target="_top"
                  merchQueryParam={merchRec}
                  brandTitleMaxLine={4}
                  disableShopThisCollection
                  iframeAnalyticsData={iframeAnalytics(iframeAnalyticsObject, 'click')}
                  isIframe
                />
                <ProductRating
                  itemId={pod.itemId}
                  target="_top"
                  merchQueryParam={merchRec}
                  iframeAnalyticsData={iframeAnalytics(iframeAnalyticsObject, 'click')}
                  isIframe
                />
                <PodSpacer padding={['T4']}>
                  <Price
                    itemId={pod.itemId}
                    large={false}
                    storeId={storeId}
                    displayEachUom={false}
                    hideSavingsText={!preferredPriceFlag}
                    showPreferredPricingBadge
                  />
                </PodSpacer>
              </PodSection>
            </div>
          </div>
          <PodSection noPadding>
            <div className="sui-w-full sui-p-3">
              <AddToCart
                cartOptions={options}
                variant="secondary"
                cartReqParams={itemDetails}
                onClick={atcButtonLoading}
                onSuccess={onSuccess}
                onFail={onFail}
                loading={loading}
              >
                {buttonText}
              </AddToCart>
            </div>
          </PodSection>
        </>
      )}
    />
  );
};

VerticalRecsDrawer.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductRating,
  ProductATC,
  Price,
  ProductHeader
);

VerticalRecsDrawer.propTypes = {
  itemId: stringType.isRequired,
  apiName: stringType.isRequired,
  storeId: stringType,
  position: numType,
  strategy: stringType,
  parent: stringType,
  channel: stringType,
  anchorProduct: stringType,
  preferredPriceFlag: boolType,
  isAppliance: boolType,
  updateRecsATCButton: func
};

VerticalRecsDrawer.defaultProps = {
  storeId: '',
  position: null,
  preferredPriceFlag: false,
  strategy: 'project-based',
  channel: '',
  parent: '',
  anchorProduct: '',
  isAppliance: false,
  updateRecsATCButton: null
};
VerticalRecsDrawer.displayName = 'VerticalRecommendation';
